// HomePageSummary_new.jsx migration (Phase E). Keys ordered to match the file's own reading order:
// Answer-Key prompt Card (button/modal/iframe title), Application Summary Card header + field
// labels, "Note" Alert titles, Application Progress Card header, then the Step-1 wizard content
// section labels in the order they appear (Personal Information, Qualification Details, Photo &
// Signature Upload, Preview Of Candidate Details), then the remaining steps' section labels
// (View/Print Challan, Make Payment / Submit Form, View/Print Receipt, Exam Card, Result).
//
// Extractions: candidateNameLabel, appliedPostLabel, currentStatusLabel, applicationSummaryHeader,
// applicationProgressHeader, personalInformationLabel, qualificationDetailsLabel,
// photoSignatureUploadLabel, previewCandidateDetailsLabel, viewPrintChallanLabel, makePaymentLabel,
// submitFormLabel, viewPrintReceiptLabel, examCardLabel, resultLabel were all already bilingual in
// the file (English + Marathi via the "English <br/> (मराठी)" pattern, the displayInGrid two-div
// pattern, or an inline "English / मराठी" string) — zero new translation authored for those. Note
// examCardLabel's Marathi ("प्रिंट करा" = "Print") looks like a copy/paste mismatch in the file's own
// original text (it literally means "Print", not "Exam Card") but is preserved verbatim per the
// extraction-not-correction rule; flagging here for a future content fix, not fixing it in this pass.
//
// answerKeyButtonLabel had an existing Marathi-only button (no English anywhere in the file) — the
// English half is AI-authored, needs linguistic QA; the Marathi half is the file's own extracted text.
// closeButtonLabel, answerKeyViewerTitle, and noteLabel had no existing Marathi anywhere in the file
// — AI-authored, needs linguistic QA. noteLabel's Marathi ("सूचना") matches the term this same file's
// aakshepMessage/Exam_note Alert blocks are functionally about (an informational notice).
export default {
  // Answer-Key prompt Card (QuestionAnswerSheetModal).
  answerKeyButtonLabel: {
    en: 'Click Here for Answer Key',
    mr: 'प्रश्न उत्तरपत्रिका (Answer Key) करिता येथे क्लिक करावे'
  }, // AI-authored (en half), needs linguistic QA
  closeButtonLabel: { en: 'Close', mr: 'बंद करा' }, // AI-authored, needs linguistic QA
  answerKeyViewerTitle: { en: 'Answer Key Viewer', mr: 'उत्तरपत्रिका दर्शक' }, // AI-authored, needs linguistic QA

  // Application Summary Card.
  applicationSummaryHeader: { en: 'Application Summary', mr: 'अर्ज सारांश' },
  candidateNameLabel: { en: 'Candidate Name', mr: 'उमेदवाराचे नाव' },
  appliedPostLabel: { en: 'Applied Post', mr: 'अर्ज केलेले पद' },
  currentStatusLabel: { en: 'Current Status', mr: 'सद्य स्थिती' },

  // "Note" Alert block titles (aakshepMessage + Exam_note blocks share this same title text).
  noteLabel: { en: 'Note', mr: 'सूचना' }, // AI-authored, needs linguistic QA

  // Application Progress Card.
  applicationProgressHeader: { en: 'Application Progress', mr: 'अर्ज प्रगती' },

  // Step 1 content section labels.
  personalInformationLabel: { en: 'Personal Information', mr: 'वैयक्तिक माहिती' },
  qualificationDetailsLabel: { en: 'Qualification Details', mr: 'शैक्षणिक माहिती' },
  photoSignatureUploadLabel: { en: 'Photo & Signature Upload', mr: 'फोटो आणि स्वाक्षरी अपलोड' },
  previewCandidateDetailsLabel: {
    en: 'Preview Of Candidate Details',
    mr: 'उमेदवाराच्या तपशीलांचे पूर्वावलोकन'
  },

  // Step 2-5 content section labels.
  viewPrintChallanLabel: { en: 'View/Print Challan', mr: 'चलन पहा / प्रिंट करा' },
  makePaymentLabel: { en: 'Make Payment', mr: 'पेमेंट' },
  submitFormLabel: { en: 'Submit Form', mr: 'सबमिट फॉर्म' },
  viewPrintReceiptLabel: { en: 'View/Print Receipt', mr: 'पावती पहा / प्रिंट करा' },
  // "Admit Card / Hall Ticket Standardization" phase: "Exam Card" -> "Hall Ticket" (terminology freeze
  // — see modules/i18n/pages/examCard.js's header comment). Also corrects this entry's Marathi, which
  // was 'प्रिंट करा' ("Print") — a copy/paste mismatch flagged (not fixed) at the time this file's own
  // comment above was written; now genuinely translated as "प्रवेशपत्र" (Hall Ticket/Admit Card, the
  // term already used everywhere else in this app for this exact document).
  examCardLabel: { en: 'Hall Ticket', mr: 'प्रवेशपत्र' },
  resultLabel: { en: 'Result', mr: 'निकालपत्रक' },

  // Phase C.7.2 (Candidate Experience Shell, §21 stepper foundation): the Application Progress
  // Steps header previously showed generic "Step 1"/"Step 2"/etc. titles with no indication of what
  // each step actually contains — these give each of the 5 (or 4, when IsExamPaymentOnline collapses
  // the Challan step out) header positions a real, descriptive label, reusing the same grouping the
  // step's own content already uses just below it. No existing bilingual text covered this (the
  // titles were literally just "Step N" placeholders, not real content) — AI-authored, needs
  // linguistic QA, same as this file's other AI-authored entries above.
  stepDetailsTitle: { en: 'Application Details', mr: 'अर्ज तपशील' },
  stepChallanTitle: { en: 'Fee Challan', mr: 'शुल्क चलन' },
  stepPaymentTitle: { en: 'Payment / Submission', mr: 'पेमेंट / सबमिशन' },
  // "Admit Card / Hall Ticket Standardization" phase: "Admit Card" -> "Hall Ticket" — this was the
  // exact "confusing mixture" the phase called out (this stepper title said "Admit Card" while the
  // step's own action row, examCardLabel above, said "Exam Card"). Marathi (प्रवेशपत्र) is unchanged —
  // already the term used everywhere else in this app for this exact document, reused rather than
  // inventing a new translation for "Hall Ticket" specifically.
  stepReceiptTitle: { en: 'Receipt & Hall Ticket', mr: 'पावती आणि प्रवेशपत्र' },
  stepResultTitle: { en: 'Result', mr: 'निकाल' }
};
